<template>
    <div style="margin-top: 10px">
        <div class="row">
            <div class="col-md-12">
                <label>Smart Card</label>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-sm-8 col-xs-6">
                <base-input v-model="model.Aux1" @blur="change" :maxlength="18"></base-input>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <money-with-indicator v-model="model.Importe" v-on:blur="change" v-on:validatedOK="onSaldoOK"/>
            </div>
        </div>
    </div>
</template>

<script>
    import MoneyWithIndicator from '@/components/Custom/MoneyWithIndicator';

    export default {
        components: {
            "money-with-indicator": MoneyWithIndicator
        },
        props: {
            model: {
                                Aux1:'',
                                Aux2:'',
                                Aux3:'',
                                Aux4:'',
                                Importe:'',
                                Validate:false,
                                Errors:[]
                        }
        },    
        data() {
            return {
                             
            }
        }, 
        methods: {
            change(element){
                this.validate();
                                this.$emit('input', this.model);
            },
            validate(){
                let context = this;
                context.model.Errors = [];

                if(context.model.Aux1.length==0){
                    context.model.Validate = false;
                    context.model.Errors.push("Debe ingresar el número de tarjeta");
                }
                else if(context.model.Aux1.length != 18 && context.model.Aux1.length != 12)
                {
                    context.model.Validate = false;
                    context.model.Errors.push("La tarjeta debe tener entre 8 y 12 digitos");
                }
                else if(context.model.Importe<= 0)
                {
                    context.model.Validate =false;
                    context.model.Errors.push("El importe no puede ser menor que 0");
                }
                else{
                    context.model.Validate = true;
                }
            },
            onSaldoOK(val) {
                this.$emit("saldoOK", val);
            }
        }
    }
</script>